import { FulfillmentContactParty, OrderPaymentTerm, PricingVector, ProductPlatform } from "client/api-v2";

export const quoteExpiryWarningDays = 14;
export const subscriptionTermWarningDays = 10;
export const orderSearchHint = "Search by Quote Reference, Subscription Name or ID, License Key or Customer";
export const selfServeLabel = "Self-serve (no rep)";

export const orderPaymentTermLabels: Record<OrderPaymentTerm, string> = {
  [OrderPaymentTerm.DueUponReceipt]: "Due upon receipt",
  [OrderPaymentTerm.Net30]: "Net 30",
  [OrderPaymentTerm.Net45]: "Net 45",
  [OrderPaymentTerm.Net60]: "Net 60",
  [OrderPaymentTerm.Net90]: "Net 90",
};

export const noFulfillmentContactParty = "none";

export type FulfillmentContactOption = FulfillmentContactParty | typeof noFulfillmentContactParty;

export const fulfillmentContactPartyLabels: Record<FulfillmentContactOption, string> = {
  [noFulfillmentContactParty]: "None",
  [FulfillmentContactParty.EndUser]: "End user",
  [FulfillmentContactParty.Reseller]: "Reseller",
  [FulfillmentContactParty.Both]: "Both",
};

export const vectorLabels: Record<PricingVector, string> = {
  [PricingVector.Project]: "Projects",
  [PricingVector.Machine]: "Machines",
  [PricingVector.Tenant]: "Tenants",
  [PricingVector.Target]: "Targets",
};

export const productPlatformLabels: Record<ProductPlatform, string> = {
  [ProductPlatform.OctopusCloud]: "Cloud",
  [ProductPlatform.OctopusServer]: "Self-hosted",
};

export function crmAccountUrl(crmId: string): string {
  return `https://app.hubspot.com/contacts/octopus/company/${crmId}`;
}
